import { FLOW_TYPE } from './constants';

export function singularExperienceType(type) {
  return type === FLOW_TYPE ? 'Flow' : 'Pin';
}
export function singularExperienceTitle(type) {
  return type === FLOW_TYPE ? 'Flow' : 'Pin Experience';
}
